/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import Header from '../Header';
import StyleContainerVideo from './style';
import EventEditAtresmedia from '../EventEditAtresmedia';

class EventPlayerEditAtresmedia extends Component {
  render() {
    return (
      <div
        className="pressResume_container"
        style={{ backgroundColor: '#FFF' }}
      >
        <Header />
        <StyleContainerVideo>
          <EventEditAtresmedia />
        </StyleContainerVideo>
      </div>
    );
  }
}

export default EventPlayerEditAtresmedia;
